// CustomFieldManager.jsx
import { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  BsPerson,
  BsBriefcase,
  BsBuildings,
  BsBox,
  BsCheck2Square,
  BsArrowLeft,
  BsAmazon,
} from "react-icons/bs";

import { SalesOrder } from "./SalesOrder";
import { Button } from "react-bootstrap";

import { InvoiceOrder } from "../Invoice/InvoiceOrder"
import { RecurringInvoices } from "../RecurringInvoices/RecurringInvoices";
import { PaymentReceviedOrder } from "../paymentRecevied/PaymentReceviedOrder";
const tabs = [
  { key: "sales", label: "Sales Order", icon: 'ti ti-report-analytics' },
  { key: "invoice", label: "Invoice", icon: 'ti ti-file-invoice' },
  { key: "recurringInvoice", label: "Recurring Invoices", icon: 'ti ti-file-time' },
  // { key: "i", label: "Delivery Challan"},
  // { key: "inv", label: "Payment Links"},
  { key: "paymentRecevied", label: "Payment Received", icon: 'bx bx-rupee' },

];

const componentMap = {
  sales: <SalesOrder />,
  invoice: <InvoiceOrder />,
  recurringInvoice: <RecurringInvoices />,
  // company: <CompanyFields />,
  // quotation: <QuotationField />,
  // sales: <SellsOrderField/>,
  paymentRecevied: <PaymentReceviedOrder />
};

const TabIndex = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const defaultTab = "sales";
  const initialTab = searchParams.get("type") || defaultTab;

  const isValidTab = (key) => tabs.some((tab) => tab.key === key);
  const [selectedTab, setSelectedTab] = useState(
    isValidTab(initialTab) ? initialTab : defaultTab
  );
  const [underlineMargin, setUnderlineMargin] = useState("2%");
  // Sync selected tab with URL on tab change
  // const handleTabChange = (tabKey) => {
  //   setSelectedTab(tabKey);
  //   const params = new URLSearchParams(location.search);
  //   const index = tabs.findIndex((t) => t.key === key);
  //    setUnderlineMargin(`${index * 2}%`);
  //   params.set("type", tabKey);
  //   const newUrl = `${location.pathname}?${params.toString()}`;
  //   navigate(newUrl);
  // };

  const handleTabChange = (tabKey) => {
    setSelectedTab(tabKey);

    const index = tabs.findIndex((t) => t.key === tabKey);

    // 2% per tab
    if (tabKey === "invoice") {
      setUnderlineMargin("1.3%");
    } else if (tabKey === "sales") {
      setUnderlineMargin("2%");
    } else {
      setUnderlineMargin("4%");
    }


    const params = new URLSearchParams(location.search);
    params.set("type", tabKey);

    navigate(`${location.pathname}?${params.toString()}`);
  };


  // Smart Back Button: go back if from /settings/preference, else redirect
  const handleBack = () => {
    if (document.referrer.includes("/settings/preference")) {

      navigate(-1);
    } else {

      navigate("/settings/preference");
    }
  };


  return (
    <>
      <style>
        {`
          .salesOrderTabs {
            box-shadow: none;
            background: transparent !important;
          }
        `}
      </style>
      <div className="py-4 position-relative ">

        <div className={`d-flex align-items-center  nav nav-tabs nav-underline salesOrderTabs`} >

          <div className="d-flex nav nav-tabs gap-2" style={{ border: "none", marginTop: "-32px", }}>
            {tabs.map((tab) => (
              <div
                key={tab.key}
                className="nav-item"
                style={{ cursor: "pointer" }}
                onClick={() => handleTabChange(tab.key)}
              >
                <span
                  className={`nav-link salesOrderTabsLInks px-3 py-2 d-flex align-items-center gap-1 ${selectedTab === tab.key ? "active fw-bold" : ""
                    }`}
                  style={selectedTab === tab.key ? { "--dynamic-margin": underlineMargin } : {}}
                >
                  <i class={`${tab.icon}`}></i>
                  {tab.label}
                </span>
              </div>
            ))}

          </div>

        </div>

        {/* Render selected tab component */}

        <div className="">{componentMap[selectedTab] || null}</div>
      </div>

      <style jsx>
        {`
        .salesOrderTabsLInks.nav-link:hover{
            border: 1px solid #dddddd !important;
            font-weight: 500 !important;
                 border-bottom: 1px solid #dddddd !important;
            border-bottom-color: #dddddd !important;
        }
        .salesOrderTabsLInks.nav-link{
            border: 1px solid #dddddd !important;
                background: #e4e3e3 !important;
    color: #4e4e4e !important;
            font-weight: 500 !important;
            border-radius: 5px;
            font-size: 13px !important;
            height: 29px !important;
          
        }
        .salesOrderTabsLInks.nav-link.active{
            border: 1px solid #7a3a5e !important;
            background: #7a3a5e !important;
            color: #fff !important;
            font-weight: 500 !important;
            font-size: 13px !important;
              height: 29px !important;
        }
               .salesOrderTabsLInks.nav-link.active:before{
display: none !important;
        }

        `}
      </style>
    </>
  );

};

export default TabIndex;